import {
  chakra,
  ChakraComponent,
  ChakraProps,
  shouldForwardProp,
} from "@chakra-ui/react";
import { isValidMotionProp, motion, MotionProps } from "framer-motion";

export type MotionBoxProps = Omit<ChakraProps, keyof MotionProps> &
  MotionProps & {
    as?: React.ElementType;
  };

const MotionBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
}) as ChakraComponent<typeof motion.div, MotionBoxProps>;

export default MotionBox;
